import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, query, limit } from 'firebase/firestore';
import { Mail, MapPin, Phone, Instagram, Linkedin, Facebook } from 'lucide-react';
import './Footer.css';
import bigmaLogo from '../../assets/bigmalogo.png';
import { db } from '../firebase/firebase-config';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const [footerInfo, setFooterInfo] = useState(null);
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { t, lang } = useLanguage();

  // Firestore'dan ayarları çekiyoruz kanka
  useEffect(() => {
    const fetchFooterSettings = async () => {
      try {
        const q = query(collection(db, "settings"), limit(1));
        const snap = await getDocs(q);
        if (!snap.empty) {
          setFooterInfo(snap.docs[0].data());
        }
      } catch (error) {
        console.error("Footer verileri çekilemedi:", error);
      }
    };
    fetchFooterSettings();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Sol: Logo ve Kısa Açıklama */}
        <div className="footer-section about">
          <div className="footer-logo">
            <img src={bigmaLogo} alt="Bigma Yem Logo" className="footer-logo-img" />
          </div>
          <p>
            {lang === 'TR' 
              ? "Yüksek verimli rasyonlarla hayvancılıkta kalite ve güvenin adresi. Modern üretim tesislerimizde geleceğin hayvancılığını inşa ediyoruz."
              : lang === 'AR'
              ? "عنوان الجودة والثقة في الثروة الحيوانية مع حصص غذائية عالية الكفاءة. نحن نبني مستقبل الإنتاج الحيواني في منشآت الإنتاج الحديثة لدينا."
              : "The address of quality and trust in livestock with high-efficiency rations. We are building the future of livestock in our modern production facilities."}
          </p>
          
          {/* Sosyal Medya İkonları - Dinamik */}
          <div className="footer-social-icons">
            {footerInfo?.instagram && (
              <a href={footerInfo.instagram} target="_blank" rel="noreferrer"><Instagram size={20} /></a>
            )}
            {footerInfo?.linkedin && (
              <a href={footerInfo.linkedin} target="_blank" rel="noreferrer"><Linkedin size={20} /></a>
            )}
            {footerInfo?.facebook && (
              <a href={footerInfo.facebook} target="_blank" rel="noreferrer"><Facebook size={20} /></a>
            )}
          </div>
        </div>

        {/* Orta: Hızlı Linkler */}
        <div className="footer-section links">
          <h4>{lang === 'TR' ? "Hızlı Menü" : lang === 'AR' ? "القائمة السريعة" : "Quick Menu"}</h4>
          <Link to="/">{t('navbar.home')}</Link>
          <Link to="/urunlerimiz">{t('navbar.products')}</Link>
          <Link to="/yem-katkilari">
            {lang === 'TR' ? "Yem Katkıları" : lang === 'AR' ? "إضافات الأعلاف" : "Feed Additives"}
          </Link>
          <Link to="/hakkimizda">{t('navbar.about')}</Link>
          <Link to="/iletisim">{t('navbar.contact')}</Link>
        </div>

        {/* Sağ: İletişim Bilgileri - Dinamik */}
        <div className="footer-section contact">
          <h4>{t('navbar.contact')}</h4>
          <div className="footer-contact-item">
            <Phone size={18} color="#f59e0b" />
            <span>{footerInfo?.phone || "0346 218 18 25"}</span>
          </div>
          <div className="footer-contact-item">
            <Mail size={18} color="#f59e0b" />
            <span>{footerInfo?.email || "info@bigmagrup.com.tr"}</span>
          </div>
          <div className="footer-contact-item">
            <MapPin size={18} color="#f59e0b" />
            <span>
              {footerInfo?.address 
                ? (lang === 'TR' ? footerInfo.address : lang === 'AR' ? `${footerInfo.address} / تركيا` : `${footerInfo.address} / Turkey`)
                : (lang === 'TR' ? "Sivas Organize Sanayi Bölgesi" : lang === 'AR' ? "منطقة سيواس الصناعية المنظمة" : "Sivas Organized Industrial Zone")}
            </span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container bottom-flex">
          <p>
            © 2026 Bigma Yem Sanayi. {lang === 'TR' ? "Tüm Hakları Saklıdır." : lang === 'AR' ? "جميع الحقوق محفوظة." : "All Rights Reserved."}
          </p>
          <div className="developer-tag">Designed by Otrera Digital</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;